import React, { useEffect, useRef, useState } from "react";
import logo from "../../../Images/loyalStringLogoWide.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { adminLoggedIn } from "../../../../redux/action/Actions";
import { addToken } from "../../../../redux/action/Actions";
import "../../PagesStyles/AdminPanelLogin.css";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { MdLogin } from "react-icons/md";
import { a172, a62, a94 } from "../../../Api/RootApiPath";
import GSHeading from "../../GoldString/GSHeading/GSHeading";
import introVideo from "../IntroVideo/LoyalString1.mp4";
import zIndex from "@mui/material/styles/zIndex";
import { ClipLoader } from "react-spinners";
import ErrorModal from "../../../Other Functions/popup";
import { setPermissions } from "../../../../redux/action/Actions";
import style from "../../PagesStyles/AdminPageLogin.module.css";
import { AdminFooter } from "../AdminFooter/AdminFooter";
import toast from "react-hot-toast";

export default function AdminPanelLogin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [otpInput, setOtpInput] = useState("");
  const [otpRcvd, setOtpRcvd] = useState("");
  const [ldata, setLdata] = useState("");
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const [errorMessage, setErrorMessage] = useState(null);
  const [emailForOtp, setEmailForOtp] = useState("");

  const [playVideo, setPlayVideo] = useState(false);
  const allStates = useSelector((state) => state);
  const adminLogged = allStates.reducer1;

  const usernameRef = useRef(null);
  const passwordRef = useRef(null);

  const [errors, setErrors] = useState({ username: "", password: "" });

  useEffect(() => {
    // Focus the username field on component mount
    if (usernameRef.current) {
      usernameRef.current.focus();
    }
  }, []);

  useEffect(() => {
    console.log("username", username);
    console.log("password", password);
  }, [username, password]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (username && !password) {
        passwordRef.current.focus(); // Move focus to password field if username is entered
      } else if (password) {
        handleLogin(e); // Trigger login if both fields are filled
      }
    }
  };

  // let Entryby_Staff_id = parseInt(adminLoggedIn);

  // console.log(adminLogged, "adminLogged");
  // console.log(adminLogged, "adminLogged");
  const loggedIn = (user) => {
    // dispatch(adminLoggedIn(user));
    dispatch(adminLoggedIn(user));
  };
  const addingToken = (user) => {
    // dispatch(adminLoggedIn(user));
    dispatch(addToken(user));
  };
  useEffect(() => {
    let showPasswordOption = document.getElementById(
      "adminPanelLoginFormShowPasswordButton"
    );
    if (showPasswordOption && showPassword === true) {
      showPasswordOption.classList.add("passwordVisible");
      showPasswordOption.classList.remove("passwordHidden");
    } else if (showPasswordOption && showPassword === false) {
      showPasswordOption.classList.add("passwordHidden");
      showPasswordOption.classList.remove("passwordVisible");
    } else {
      null;
    }
  }, [showPassword]);

  console.log(adminLogged, "adminLogged");
  let isAuthenticated = "";
  if (adminLogged.Clients) {
    isAuthenticated = true;
    // if (adminLogged.toString() === "1") {
    //   isAuthenticated = true;
  } else if (adminLogged.toString() === "2") {
    isAuthenticated = true;
  } else if (adminLogged.toString() === "3") {
    isAuthenticated = true;
  } else if (adminLogged.toString() === "4") {
    isAuthenticated = true;
  } else if (adminLogged.StatusType === true) {
    isAuthenticated = true;
  } else isAuthenticated = false;

  const validate = () => {
    const newErrors = {};
    if (!username) {
      newErrors.username = "Username is required";
    }
    if (!password) {
      newErrors.password = "Password is required";
    }
    return newErrors;
  };

  const handleSendOtp = async (email) => {
    const formData = {
      EmpEmail: email,
    };
    try {
      toast.success("OTP Sent Successfully!",{
        duration:  3000,
        position: 'top-center'
      })
      const response = await fetch(a172, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();

     

      // alert(data.Message);
      setOtpRcvd(data.Data);
      // loggedIn(data.Employee);
      // navigate("/adminhome");
    } catch (error) {
      // if (response.status === 500) {
      // console.log(response.status);
      // console.log(response.statusText);
      // }
      console.error(error);
      // alert(error.message);
    }
  };

  const handleLogin = async (e) => {
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});

    isAuthenticated = false;
    e.preventDefault();
    const formData = {
      Username: username,
      Password: password,
    };

    setLoading(true);
    try {
      const response = await fetch(a94, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();

      if (data.Message) {
        toast.error(data.Message, {
          duration: 3000,
          position: "top-center",
        });
        setLoading(false);
        // setErrorMessage(data.Message)
        // setShowModal(true)
      } else {
        console.log(data, "checking employeedata");
        setEmployeeDetails(data.Employee);
        if (isAuthenticated == true) {
          // loggedIn(employeeDetails);
          setLoading(false);
          navigate("/adminhome");
        } else {
          setLoading(false);
          // navigate("/adminhome");
          // setCurrentStep(2);
          // handleSendOtp(data.Employee.Clients.EmailForOTP);
          setLdata(data);
          await fetchPermissions(
            data.Employee.Clients.ClientCode,
            data.Employee.EmployeeId,
            data.Employee.SuperAdmin
          );
          // setEmailForOtp(data.Employee.Clients.EmailForOTP);
        }
      }
    } catch (error) {
      // if (response.status === 500) {
      // console.log(response.status);
      // console.log(response.statusText);
      // }
      console.error(error);
      setErrorMessage(error);
      // setLoading(false)
      // alert(error.message);
    }
  };

  // useEffect(() => {
  //   if (playVideo) {
  //     // Assume the video element has an ID of "introVideo"
  //     const videoElement = document.getElementById("introVideo");
  //     if (videoElement) {
  //       videoElement.play();
  //       videoElement.onended = () => {
  //         navigate("/adminhome");
  //       };
  //     }
  //   }
  // }, [playVideo, navigate]);

  const [permissionsLoaded, setPermissionsLoaded] = useState(false);

  const fetchPermissions = async (clientCode, employeeid, admin) => {
    try {
      const response = await fetch(
        "https://testing.loyalstring.co.in/api/RoleManagement/GetAllUserPermissions",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ClientCode: clientCode,
            EmployeeId: employeeid,
          }),
        }
      );

      const data = await response.json();

      const matchingUser = data.find((user) => user.UserId === employeeid);

      if (matchingUser) {
        const permissions = matchingUser.Modules || [];
        dispatch(setPermissions(permissions)); // Dispatch the permissions to Redux
        console.log("Permissions set for UserId:", employeeid);
        setPermissionsLoaded(true); // Set permissions loaded to true
      } else {
        if (admin === 1) {
          const permissions = [];
          dispatch(setPermissions(permissions)); // Dispatch the permissions to Redux
          console.log("superadmin set for UserId:", employeeid);
          setPermissionsLoaded(true); // Set permissions loaded to true
        } else {
          console.warn(`No permissions found for UserId: ${employeeid}`);
          setPermissionsLoaded(false); // Set to false if no matching user is found
          alert("you dont have permissions");
        }
      }

      // const permissions = data[0]?.Modules || [];
      // dispatch(setPermissions(permissions)); // Dispatch the permissions to Redux
      // console.error("Permissions got ", data);
      // setPermissionsLoaded(true); // Set permissions loaded to true
    } catch (error) {
      console.error("Error fetching permissions:", error);
      setPermissionsLoaded(false); // Ensure it's set to false if there's an error
    }
  };

  useEffect(() => {
    console.log("emailForOtp", emailForOtp);
  }, [emailForOtp]);

  useEffect(() => {
    if (permissionsLoaded) {
      loggedIn(ldata.Employee);
      navigate("/adminhome");
    }
  }, [permissionsLoaded]);

  const handleEmployeeValid = async (e) => {
    e.preventDefault();
    if (otpInput !== "" && otpRcvd !== "") {
      if (parseInt(otpInput) === parseInt(otpRcvd)) {
        // loggedIn(employeeDetails);

        console.log("checking user ", employeeDetails);

        await fetchPermissions(
          employeeDetails.Clients.ClientCode,
          employeeDetails.EmployeeId,
          employeeDetails.SuperAdmin
        );

        // Check if permissions are loaded
        // if (permissionsLoaded) {
        //     // loggedIn(ldata.Employee);
        //     // navigate("/adminhome");
        // } else {
        //     console.error("Permissions failed to load.");
        // }
      } else {
        alert("Incorrect OTP");
      }
    }
  };

  const reloadData = () => {
    setShowModal(false); // Close the modal
    // loadData(); // Reload data
  };

  // const handleLogin = () => {
  //   if (username == "admin" && password == "Testing@123") {
  //     // alert(`Welcome ${username}`);
  //     loggedIn("1");
  //     navigate("/adminhome");
  //   } else if (username == "Branch2" && password == "Testing@123") {
  //     // alert(`Welcome ${username}`);
  //     navigate("/adminhome");
  //     loggedIn("2");
  //   } else if (username == "Staff2" && password == "soccerlover") {
  //     // alert(`Welcome ${username}`);
  //     navigate("/adminhome");
  //     loggedIn("3");
  //   } else if (username == "Staff3" && password == "chocolate123") {
  //     // alert(`Welcome ${username}`);
  //     navigate("/adminhome");
  //     loggedIn("4");
  //   } else if (username == "Staff4" && password == "beach2020") {
  //     // alert(`Welcome ${username}`);
  //     navigate("/adminhome");
  //     loggedIn("5");
  //   } else {
  //     alert("Sorry Incorrect Details");
  //   }
  // };

  // const handleLogin = async () => {
  //   // Assuming it's a GET request, append parameters to the URL
  //   const apiUrl = `${a62}?email=${username}&password=${password}`;

  //   try {
  //     const response = await fetch(a62, {
  //       method: "POST", // Use POST method
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         email: username,
  //         password: password,
  //       }),
  //     });
  //     const data = await response.json();

  //     // Process the response data, e.g., store the token
  //     const token = data.token;
  //     // Perform actions with the token, such as storing it in state or localStorage
  //     if (data.token) {
  //       console.log(data.token);
  //       loggedIn("1");
  //       addingToken(`${data.token}`);
  //       // console.log("Login successful. Token:", token);
  //       navigate("/adminhome");
  //       showUser();
  //     }
  //     // Optionally, return the token or other relevant data
  //     return token;
  //     // Rest of the code remains the same...
  //   } catch (error) {
  //     console.error("Error during login:", error.message);
  //     throw error;
  //   }
  // };

  // const allStates = useSelector((state) => state);
  // const isAdminLoggedIn = allStates.reducer1;
  // const isAdminTokenIn = allStates.reducer3;
  // const showUser = () => {
  //   console.log(isAdminLoggedIn, "isAdminLoggedIn");
  //   console.log(isAdminTokenIn, "isAdminToken");
  // };

  return (
    <div className={style.adminPanelLoginOuterBox}>
      {playVideo ? (
        <video
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: "1000",
            backgroundColor: "#fff",
          }}
          id="introVideo"
        >
          <source src={introVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <>
          <GSHeading />
          {loading ? (
            // Show spinner while loading
            <div className="spinner-container">
              <ClipLoader size={50} color={"#123abc"} loading={loading} />
              <p>Loading data...</p>
            </div>
          ) : (
            <div>
              <ErrorModal
                isOpen={showModal}
                onRequestClose={() => {
                  setShowModal(false); // Close the modal
                  // navigate("/adminhome"); // Redirect t
                }}
                onReload={reloadData} // Pass reload function
                message={errorMessage}
              />

              {currentStep === 1 ? (
                <div className={style.adminPanelLoginInnerBox}>
                  <div className={style.adminPanelLoginBox}>
                    <div>
                      <div className={style.adminPanelLoginFormLabelBox}>
                        <div className={style.adminPanelLoginFormLabelInnerBox}>
                          <label htmlFor="inputEmail">Username</label>
                        </div>
                      </div>
                      <div className={style.adminPanelLoginFormInputBox}>
                        {/* <div className="adminPanelLoginFormInputInnerBox"> */}
                        <input
                          type="text"
                          id="inputEmail"
                          value={username}
                          ref={usernameRef}
                          onChange={(e) => setUsername(e.target.value)}
                          onKeyDown={handleKeyPress}
                        />
                        {/* </div> */}
                      </div>

                      {errors.username && (
                        <div
                          style={{ padding: "0", textAlign: "start" }}
                          className={style.adminPanelLoginFormLabelInnerBox}
                        >
                          <label style={{ color: "red", fontSize: "12px" }}>
                            {errors.username}
                          </label>
                        </div>
                      )}

                      <div className={style.adminPanelLoginFormLabelBox}>
                        <div className={style.adminPanelLoginFormLabelInnerBox}>
                          <label htmlFor="inputPassword">Password</label>
                        </div>
                      </div>
                      <div className={style.adminPanelLoginFormInputBox}>
                        <div className={style.adminPanelLoginFormInputInnerBox}>
                          <input
                            type={showPassword ? "text" : "password"}
                            id={style.inputPassword3}
                            value={password}
                            ref={passwordRef}
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyDown={handleKeyPress}
                          />

                          <button
                            style={{ cursor: "pointer" }}
                            id={style.adminPanelLoginFormShowPasswordButton}
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? (
                              <AiOutlineEyeInvisible
                                className={
                                  style.adminPanelLoginFormShowPasswordIcon
                                }
                              />
                            ) : (
                              <AiOutlineEye
                                className={
                                  style.adminPanelLoginFormShowPasswordIcon
                                }
                              />
                            )}
                          </button>
                        </div>
                      </div>

                      {errors.password && (
                        <div
                          style={{ padding: "0", textAlign: "start" }}
                          className={style.adminPanelLoginFormLabelInnerBox}
                        >
                          <label style={{ color: "red", fontSize: "12px" }}>
                            {errors.password}
                          </label>
                        </div>
                      )}

                      <div className={style.adminPanelLoginFormButtonOuterBox}>
                        <button
                          type="submit"
                          onClick={(e) => handleLogin(e)}
                          className={style.adminPanelLoginFormButtonInnerBox}
                        >
                          <div>Login</div>
                        </button>
                      </div>
                      {/* </form> */}
                      <div className={style.adminPanelLoginFormRegisterBox}>
                        <p>Dont have an account ?</p>
                        <h5 onClick={() => navigate("/client_onboarding")}>
                          Register Here
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              ) : currentStep == 2 ? (
                <div style={{ marginTop: "30px" }} className={style.adminPanelLoginInnerBox}>
                  <div className={style.adminPanelLoginBox}>
                    <form onSubmit={handleEmployeeValid}> {/* Use form to handle submission */}
                      <div className={style.adminPanelLoginFormLabelBox}>
                        <div className={style.adminPanelLoginFormLabelInnerBox}>
                          <label htmlFor="otpInput">Enter OTP Send to Registered Email</label>
                        </div>
                      </div>
                      <div className={style.adminPanelLoginFormInputBox}>
                        <input
                          type="number"
                          id="otpInput"
                          value={otpInput}
                          onChange={(e) => setOtpInput(e.target.value)}
                          autoFocus
                        />
                      </div>
        
                      <div className={style.adminPanelLoginFormRegisterBox}>
                        <p>Didn't receive OTP?</p>
                        <h5
                          style={{ color: "blue", cursor: 'pointer' }}
                          onClick={() => handleSendOtp(emailForOtp)}
                        >
                          Resend OTP
                        </h5>
                      </div>
        
                      <div className={style.adminPanelLoginFormButtonOuterBox}>
                        <button
                          type="submit"  // Change button type to submit
                          className={style.adminPanelLoginFormButtonInnerBox}
                        >
                          <MdLogin style={{ marginRight: "5px" }} />
                          <div>Sign in</div>
                        </button>
                      </div>
                    </form>
        
                    <div className={style.adminPanelLoginFormRegisterBox}>
                      <p>Don't have an account ?</p>
                      <h5 onClick={() => navigate("/client_onboarding")}>
                        Register Here
                      </h5>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          )}

          <AdminFooter />
        </>
      )}
    </div>
  );
}
